module.exports = __webpack_public_path__ + "img/cervantes-logo.3386efc6.jpg";